let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kVX56"), load("jmyQZ")]).then(() => parcelRequire('7xDLz'));